import { HomeLoading } from "@/components/home-loading.tsx";
import { LineItemsStateProvider } from "@/pages/(app)/returns/refund/hooks/use-line-items-state-context";
import { RefundLineItemsProvider } from "@/pages/(app)/returns/refund/hooks/use-refund-line-items-context";
import { CurrentReturnRequestProvider } from "@/pages/(app)/returns/utils/current-return-request-context";
import { LineItemsLoadingStateProvider } from "@/pages/(app)/returns/utils/line-items-loading-state-context";
import { useArticleScanner } from "@/pages/(app)/returns/view/hooks/use-article-scanner";
import ReturnNav from "@/pages/(app)/returns/view/components/return-nav/return-nav.tsx";
import { ReturnValidationProvider } from "@/pages/(app)/returns/view/utils/return-validation-context";
import { useGetReturnRequestSuspense } from "@babackapp/private-api-client/client/use-get-return-request";
import { Suspense } from "react";
import { Outlet, useParams } from "react-router-dom";

export default function ReturnLayout() {
  return (
    <div className="relative w-full">
      <div className="flex flex-row flex-grow w-full">
        <div className="flex flex-col flex-1 w-full">
          <div className="flex xl:flex-row flex-col-reverse justify-center gap-4 py-32 items-start relative w-full">
            <div className="flex flex-col w-full xl:w-auto">
              <Suspense fallback={<HomeLoading />}>
                <ReturnLayoutContent />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ArticleScannerMount() {
  useArticleScanner();
  return null;
}

function ReturnLayoutContent() {
  const { returnId, shopId } = useParams<{
    returnId: string;
    shopId: string;
  }>();

  const { data: returnRequest } = useGetReturnRequestSuspense({
    shopId: shopId!,
    returnRequestId: returnId!,
  });

  return (
    <CurrentReturnRequestProvider returnRequest={returnRequest}>
      <LineItemsLoadingStateProvider>
        <LineItemsStateProvider>
          <RefundLineItemsProvider>
            <ReturnValidationProvider>
              <ArticleScannerMount />
              <ReturnNav />
              <Outlet />
            </ReturnValidationProvider>
          </RefundLineItemsProvider>
        </LineItemsStateProvider>
      </LineItemsLoadingStateProvider>
    </CurrentReturnRequestProvider>
  );
}
